<template>
    <div>
        <compFormEdit ref="formbase" class="margin-layout" :formdata="getBase" v-model="formData" :col="1"></compFormEdit>
        <div class="text-right">
            <vButton theme="primary" @click="submit">{{$t('global.common.update_OK', { defaultValue: '确定'})}}</vButton>
            <vButton class="margin-left-10" @click="cancel">{{$t('global.common.operation_cancel', { defaultValue: '取消' })}}</vButton>
        </div>
        <vLoading loading fix v-if="loading"></vLoading>
    </div>
</template>

<script>
import { HttpChangeWarehouse,HttpChangeSimpleWarehouse ,HttpGetCapacity,HttpCheckCapacity} from '@/service/inbound';
import { HttpGetCusOrgWareList, } from '@/service/billing';
import { HttpFindByOrgIdAndOrgWarehouseId } from '@/service/allotment';
export default {
    props:['itemjson'],
    data(){
        return {
            formData:{},
            cusWareList:[],
            channelList:[],
            showaccount:false,
            loading:false,
            showCapacity:false,
        }
    },
    created(){
        this.getWarehouse()
        this.getCapacity()
    },
    computed:{
        getBase(){
            return [
                {
                    tag: "vSelect",
                    key: "warehouseCode",
                    options:this.cusWareList,
                    labelWidth: '90',
                    span: 24,
                    label: this.$t('fbb.inbound.change_warehouse', { defaultValue: "换仓" }),
                    props: {
                        filterable: true,
                    },
                    on:{
                        'on-attach':(attach)=>{
                            console.log(attach)
                            if(attach.warehouseType == 4){
                                this.showaccount = true
                                this.getChannel(attach.id)
                            }
                            this.checkCapacity(attach.id)
                        }
                    }
                },
                {
                    tag: "vSelect",
                    key: "sourceChannel",
                    options:this.channelList.map(item=>{
                        return {
                            value: item.accountFlag,
                            label: item.accountFlag,
                        }
                    }),
                    show:this.showaccount,
                    labelWidth: '90',
                    span: 24,
                    label: this.$t('global.common.channel', { defaultValue: "渠道" }),
                    props: {
                        filterable: true,
                    },
                },
                {
                    show:this.showCapacity,
					valueText:this.formData.restCapacity+ '/'+this.formData.totalCapacity,
                    labelWidth: '100',
                    span: 24,
                    label: "库容余量(CBM)",
                    query:true
                },
                 {
                    tag: "vInput",
                    key: "shipmentId",
                    labelWidth: '90',
                    span: 24,
                    label: "Shipment ID",
                    show:this.showaccount,
                },
                {
                    tag: "vTextarea",
                    key: "remark",
                    labelWidth: '90',
                    span: 24,
                    label: this.$t('global.common.notes', { defaultValue: "备注" }),
                    required:false,
                }
            ]
        }
    },
    methods:{
        getWarehouse(){
            HttpGetCusOrgWareList({
                customerOrgId: this.itemjson.organizationId
            }).then(res=>{
                this.cusWareList = res.data.map(item => {
        			return {
        				value: item.code,
                        label: item.code + ' (' + item.title + ')',
                        attach: {
                            id:item.id,
                            warehouseType:item.warehouseType
                        }
        			}
                })
            },err=>[
                this.cusWareList = []
            ])
        },
        getCapacity(){
            HttpGetCapacity({
                inboundPlanId:this.itemjson.id
            }).then(res=>{
               if(res.data){
                   if(res.data.restCapacity==0){
						this.formData.restCapacity = "0.0000";
					}else{
						this.formData.restCapacity = res.data.restCapacity;
					}
					if(res.data.totalCapacity==0){
						this.formData.totalCapacity = "0.0000";
					}else{
						this.formData.totalCapacity = res.data.totalCapacity;
					}
                   this.showCapacity = true;
               }
            })
        },
        checkCapacity(wareId){
            this.showCapacity = false;
            let arriveDate = this.itemjson.expectArriveDate
            if(this.itemjson.estimateArriveTime){
                arriveDate = this.itemjson.estimateArriveTime
            }
				HttpCheckCapacity({
				contextId: this.itemjson.organizationId,
				warehouseId:wareId,
				expectDate:arriveDate
			}).then(res => {
				if(res.data){
					this.showCapacity = true;
					if(res.data.restCapacity==0){
						this.formData.restCapacity = "0.0000";
					}else{
						this.formData.restCapacity = res.data.restCapacity;
					}
					if(res.data.totalCapacity==0){
						this.formData.totalCapacity = "0.0000";
					}else{
						this.formData.totalCapacity = res.data.totalCapacity;
					}
				}else{
					this.showCapacity = false;
				}
				
			});
		},
        // 根据仓库获取对应的渠道列表
		getChannel(wareId){
			HttpFindByOrgIdAndOrgWarehouseId({
				orgId:this.itemjson.organizationId,
				orgWarehouseId:wareId
			}).then(res=>{
					this.channelList = []
					this.channelList = res.data;
					
			},err=>{
				this.$$VMessage.error(err.message)
			})
		},
        async submit(){
            const valid = await this.$refs.formbase.validate();
			if (!valid) return;
            this.loading = true
            if(this.itemjson.inboundPlanOrderStatus == 20){
                HttpChangeWarehouse({
                    inboundPlanOrderNo: this.itemjson.inboundPlanOrderNo,
                    ...this.formData
                }).then(res=>{
                    this.$VMessage.success(res.message)
                    this.loading = false
                    this.cancel()
                },err=>{
                    this.$VMessage.error(err.message)
                    this.loading = false
                })
            }else{
                HttpChangeSimpleWarehouse({
                    inboundPlanOrderNo: this.itemjson.inboundPlanOrderNo,
                    ...this.formData
                }).then(res=>{
                    this.$VMessage.success(res.message)
                    this.loading = false
                    this.cancel()
                },err=>{
                    this.$VMessage.error(err.message)
                    this.loading = false
                })
            }
        },
        cancel(){
            this.$emit('on-close')
        }
    },
}
</script>